<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        Stormhaven Studios
      </router-link>
      <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >
        <div class="popover-body">
         Developers of Embers Adrift MMORPG
        </div>
      </el-popover>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <router-link class="nav-link" to="/mission-statement">
          <i class="now-ui-icons files_paper"></i>
          <p>Mission Statement</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/privacy-policy">
          <i class="now-ui-icons location_world"></i>
          <p>Privacy Policy</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/terms-of-service">
          <i class="now-ui-icons design_bullet-list-67"></i>
          <p>Terms of Service</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/products" >
          <i class="now-ui-icons tech_controller-modern"></i>
          <p>Products</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/careers" >
          <i class="now-ui-icons business_briefcase-24"></i>
          <p>Careers</p>
        </router-link>
      </li>
    </template>
  </navbar>
</template>

<script>
import { Navbar } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    Navbar,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
